import EditIcon from "@mui/icons-material/Edit";
import { Box } from "@mui/material";
import { Typography } from "@platform/design-system";

function ClickToSelect(): React.JSX.Element {
  return (
    <Box
      sx={{
        color: "text.secondary",
        fontStyle: "italic",
        display: "flex",
        alignItems: "center",
        gap: 0.5,
        cursor: "pointer",
        width: "100%",
        justifyContent: "center",
      }}
    >
      <EditIcon fontSize="small" sx={{ opacity: 0.5 }} />
      <Typography variant="body-medium">Click to select</Typography>
    </Box>
  );
}

export { ClickToSelect };
